<template>
  <div class="additional-collapse" :class="{ postfix: postfix }">
    <b-button
      class="additional-collapse-control w-100 align-items-center"
      :class="visible ? null : 'collapsed'"
      :aria-expanded="visible ? 'true' : 'false'"
      :aria-controls="`collapse-${_uid}`"
      variant="link"
      @click="handleChange"
    >
      <div class="flex-grow-1">
        {{ label }}
      </div>
      <slot name="status-icon"></slot>
      <eg-icon :icon="visible ? 'chevron-up' : 'chevron-down'" />
    </b-button>

    <div v-if="subtitle" class="subtitle">{{ subtitle }}</div>

    <b-collapse
      :id="`collapse-${_uid}`"
      :visible="visible"
      :accordion="accordion"
      @input="onInput"
    >
      <slot />
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "More options",
    },
    accordion: {
      type: String,
      default: "",
    },
    handleCollapseChange: {
      type: Function,
      default: undefined,
    },
    postfix: {
      type: Boolean,
      default: false,
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      visible: false,
    };
  },

  watch: {
    value: {
      handler(newVal) {
        this.visible = newVal;
      },
      immediate: true,
    },
  },

  methods: {
    handleChange(event) {
      this.visible = !this.visible;
      this.$emit("collapseToggled", event);
    },
    onInput(value) {
      this.visible = value;
      this.$emit("input", value);
    },
  },
};
</script>

<style scoped lang="scss">
.additional-collapse {
  padding: 1rem;
  border: 1px solid var(--color-stroke-neutral-default);
  border-radius: var(--radius-rd-300);
}

.btn {
  gap: 8px;
  padding: 0;
  margin: 0;
  text-align: left;
  color: var(--color-text-neutral-on-white);
  font-weight: var(--typography-font-weight-fw-600);
  font-size: var(--typography-font-size-fs-300);
  line-height: 2rem;

  &.btn-link:hover {
    text-decoration: none;
  }

  &:focus {
    text-decoration: none;
    box-shadow: none;
  }
}

.postfix .btn {
  &:before {
    display: none;
  }
  &::after {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: -1px;
    vertical-align: 5px;
    content: "";
    border-top: 0;
    border-right: 0.3em solid transparent;
    border-bottom: 0.3em solid;
    border-left: 0.3em solid transparent;
  }

  &.collapsed::after {
    transform: rotate(180deg);
    margin-bottom: -2px;
  }
}

.subtitle {
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0;
  margin-bottom: 24px;
}
</style>
